export default "__VITE_ASSET__7afd6839__"